import { motion } from 'framer-motion';
import React from 'react';
import { CarouselNavigationType } from '../CarouselTypes';

function CarouselDotNavigation(props: CarouselNavigationType) {
	return (
		<div className='carousel-navigation-container'>
			{props.items.map((item: any, key: number) => (
				<motion.div
					whileHover={{ scale: 1.1 }}
					whileTap={{ scale: 0.95 }}
					className={props.index === key ? 'carousel-navigation-entry active' : 'carousel-navigation-entry'}
					style={{ pointerEvents: props.index === key ? 'none' : 'all' }}
					onClick={() => props.navigationCallback(key)}
				/>
			))}
		</div>
	);
}

export { CarouselDotNavigation };
